import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RecentDocumentprops } from './Types';

export const recentDocumentApi = createApi({
  reducerPath: 'recentDocumentApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'http://isf-api-dev-1093141249.us-east-2.elb.amazonaws.com/isf/' }),
  endpoints: builder => ({
    getRecentDocument: builder.query<RecentDocumentprops[], void>({
      query: () => ({
        url: `masterDocument/getAll?is_binder_view=false&user_based_details=true&limit=10`,
        method: 'GET'
      })
    })
  })
});

export const { useGetRecentDocumentQuery } = recentDocumentApi;
